// JavaScript Document

$(document).ready(function(){

    //外部リンクにblank追加
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
        }
    }
    //外部リンクにblank追加 end

    $('.sidebar__submenu._cart').click(function() {
        if($('body').hasClass("_white")){
            $('body').removeClass("_white");
        } else {
            $('body').addClass("_white");
        }
    });
    $('.sidebar__submenu._menu, #globalnavigationclose').click(function() {
        if($('#globalnavigation').hasClass("_active")){
            $('#globalnavigation').removeClass("_active");
            $('body').removeClass("_whitemode");
        } else {
            $('#globalnavigation').addClass("_active");
            $('body').addClass("_whitemode");
        }
    });

    function scroll_effect() {
        $(".detail__figure").each(function () {
            var imgPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > imgPos - windowHeight + windowHeight / 5) {
                $(this).addClass("fade_on");
            } else {
                $(this).removeClass("fade_on");
            }
        });
    };
    $(window).on("scroll",function(){
        scroll_effect();
    });

    if($(".detail__figure").length) {
        scroll_effect();
    }

    $(window).on('load', function() {
        var url = $(location).attr('href');
        if(url.indexOf("?id=") != -1){
            var id = url.split("?id=");
            var $target = $('#' + id[id.length - 1]);
            if($target.length){
                var pos = $target.offset().top-30;
                $("html, body").animate({scrollTop:pos}, 1000, 'easeInOutExpo');
            }
        }
    });

    if($(".template-index").length) {
        var fn = function() {
            $(".header").addClass("_visible");
            $(".header__title").on('transitionend', function () {
                setTimeout(fn2,200);
            })
        };
        setTimeout(fn,500);
        
        var fn2 = function() {
            $("body").removeClass("_home");
            $(".header").addClass("_invisible");
        };
    }
    
    if($(".detail__figureouter").length) {
        let slickInitialized = false;

        function initSlick() {
            if ($(window).width() < 800) {
                if (!slickInitialized) {
                    $('.detail__figureouter').slick({
                        dots: true,
                        arrows: false,
                        infinite: true,
                        speed: 700,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        fade: true,
                        autoplaySpeed: 5000
                    });
                    slickInitialized = true;
                }
            } else {
                if (slickInitialized) {
                    $('.detail__figureouter').slick('unslick');
                    slickInitialized = false;
                }
            }
        }

        // 初回実行
        initSlick();

        // リサイズ時（デバウンス付き）
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(initSlick, 250);
        });
    };

});